import { render, staticRenderFns } from "./fotosDetail.vue?vue&type=template&id=c60de41e"
import script from "./fotosDetail.vue?vue&type=script&lang=js"
export * from "./fotosDetail.vue?vue&type=script&lang=js"
import style0 from "./fotosDetail.vue?vue&type=style&index=0&id=c60de41e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports